import HierarchicalManagement from './hierarchical_management.vue';

export default HierarchicalManagement;
